"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Render = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// If this works out, maybe the Panel component should do that, and widgets should use Panel.
// OOOH, and when loading toggles, animate the Panel in. Make the neumorphic shape shadow bounceInAndOut. That could be another cool article to write.
// This part is really weird. I think this has to be a render props patterned element. Because the whole point of this is that you don't want the child rendered AND evaluated unless the condition is met. With the current pattern (write it down for the article) the child is evaluated, but not rendered.
// return <>{when && children}</>;
const Render = (_ref) => {
  let {
    children,
    when
  } = _ref;
  // console.log("--<Render>--", when);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, when && children());
};

exports.Render = Render;
Render.propTypes = {
  children: _propTypes.default.func.isRequired,
  when: _propTypes.default.bool
};